module.exports = __webpack_public_path__ + "yogaImg1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/yogaImg1.jpg
// module id = 301
// module chunks = 0